import { remove } from 'es-toolkit';

export const upsertQueryItem =
  <T extends { id: string }>(item: T, position: 'front' | 'back' = 'front') =>
  (arr: Array<T> | undefined): Array<T> => {
    if (!arr) return [item];

    remove(arr, (i: T) => i.id === item.id);

    // Insert based on position
    if (position === 'front') {
      return [item, ...arr];
    } else {
      return [...arr, item];
    }
  };

export const updateQueryItem =
  <T extends { id: string }>(item: T) =>
  (arr: Array<T> | undefined): Array<T> => {
    if (!arr) return [item];

    return arr.map((i) => (i.id === item.id ? item : i));
  };

export const deleteQueryItem =
  <T extends { id: string }>(id: string) =>
  (arr: Array<T> | undefined): Array<T> => {
    if (!arr) return [];

    return arr.filter((i) => i.id !== id);
  };
